import {
	fetchComList
} from '@/utils/api/com'
import {formatTime } from '@/utils/common.js'
const lastMonthDate = new Date(new Date().setMonth(new Date().getMonth() - 1))
const defaultDatePickerValue = formatTime('YYYYmm', lastMonthDate)
const defaultAreaTableFilter = {
	com: null,
	dataTime: defaultDatePickerValue,
	from: null,
	to: null,
	page: 1,
	size: 10,
}
const defaultCircuitTableFilter = {
	com: null,
	dataTime: defaultDatePickerValue,
	from: null,
	to: null,
	page: 1,
	size: 10,
}
const state = {
	pagination: {
		layout: 'total, sizes,prev, pager, next',
		pageSizes:[10,20,50,100]
	},
	comList: [],
	autarkyList: [],
	participateList: [],
	areaTableLoading: true,
	areaTableFilter: {
		...defaultAreaTableFilter
	},
	circuitTableLoading: true,
	circuitTableFilter: {
		...defaultCircuitTableFilter
	},
}

const mutations = {
	UPDATE_COMDICT: (state, comList) => {
		let autarkyList = [],
			participateList = []
		comList.forEach(item => {
			if (item.type == 0) {
				autarkyList.push({
					name: item.name,
					code: item.code
				})
			} else {
				participateList.push({
					name: item.name,
					code: item.code
				})
			}
		})
		state.comList = comList
		state.autarkyList = autarkyList
		state.participateList = participateList
	},
	UPDATE_AREATABLE_LOADING: (state, loading) => {
		state.areaTableLoading = loading
	},
	UPDATE_AREATABLE_FILTER: (state, filter) => {
		state.areaTableFilter = {
			...state.areaTableFilter,
			...filter
		}
	},
	UPDATE_CIRCUITTABLE_LOADING: (state, loading) => {
		state.circuitTableLoading = loading
	},
	UPDATE_CIRCUITTABLE_FILTER: (state, filter) => {
		state.circuitTableFilter = {
			...state.circuitTableFilter,
			...filter
		}
	}
}

const actions = {
	getComDict({
		commit,
		state
	}) {
		if (state.autarkyList.length == 0 || state.participateList.length == 0) {
			fetchComList().then(res => {
				commit('UPDATE_COMDICT', res.data)
			})
		} else {
			commit('UPDATE_COMDICT', state.comList)
		}
	},
	setAreaTableLoading({
		commit
	}, loading) {
		commit('UPDATE_AREATABLE_LOADING', loading)
	},
	setAreaTableFilter({
		commit
	}, filter) {
		commit('UPDATE_AREATABLE_FILTER', filter)
	},
	resetAreaTableFilter({
		commit
	}) {
		commit('UPDATE_AREATABLE_FILTER', defaultAreaTableFilter)
	},
	setCircuitTableLoading({
		commit
	}, loading) {
		commit('UPDATE_CIRCUITTABLE_LOADING', loading)
	},
	setCircuitTableFilter({
		commit
	}, filter) {
		commit('UPDATE_CIRCUITTABLE_FILTER', filter)
	},
	resetCircuitTableFilter({
		commit
	}) {
		commit('UPDATE_CIRCUITTABLE_FILTER', defaultCircuitTableFilter)
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
